import { Injectable, inject, signal } from '@angular/core';
import { BrandStoreService } from '@portal/app/dashboard/geo-doe-config/data-stores/brand-store.service';
import { RoasCpoViewType } from '../models/RoasCpoViewType';
import { Brand } from '@portal/app/shared/types';

@Injectable({
  providedIn: 'root'
})
export class ViewTypeService {
  private readonly brandStoreService = inject(BrandStoreService);

  #brand = signal<Brand | null>(null);
  #defaultViewType = signal<RoasCpoViewType>(RoasCpoViewType.ROAS);
  defaultViewType = this.#defaultViewType.asReadonly();

  loadBrandDetails() {
    const brand = this.brandStoreService.brand;
    const roasCpoViewType = brand.roasCpoViewType as unknown as RoasCpoViewType;
    this.#brand.set(brand);
    this.#defaultViewType.set(roasCpoViewType);
  }

  updateViewTypeLocally(viewType: RoasCpoViewType): void {
    const currentBrand = this.#brand();
    if (currentBrand) {
      this.#brand.set({
        ...currentBrand,
        roasCpoViewType: viewType
      });
    }
    this.#defaultViewType.set(viewType);
  }
}
